import { defineMessages } from 'react-intl';

export const commonMessages = defineMessages({
  nodeDeleted: {
    id: 'nodeDeleted',
    defaultMessage:
      'The following item has been moved to long term storage. You can check the previous version of the item in the Published tab, on the top, or on the publishing page.',
    description: 'Node deleted',
  },
  download: {
    id: 'download',
    defaultMessage: 'Download',
    description: 'Download',
  },
  NEW: {
    id: 'NEW',
    defaultMessage: 'New',
    description: 'New',
  },
  PUBLISHED: {
    id: 'PUBLISHED',
    defaultMessage: 'Published',
    description: 'Published',
  },
  UNPUBLISHED: {
    id: 'UNPUBLISHED',
    defaultMessage: 'Unpublished',
    description: 'Unpublished',
  },
  DELETED: {
    id: 'DELETED',
    defaultMessage: 'Deleted',
    description: 'Deleted',
  },
  ARCHIVED: {
    id: 'ARCHIVED',
    defaultMessage: 'long term storage',
    description: 'Archived',
  },
  MODIFIED: {
    id: 'MODIFIED',
    defaultMessage: 'Modified',
    description: 'Modified',
  },
  all: {
    id: 'all',
    defaultMessage: 'all',
    description: 'All',
  },
  invalid: {
    id: 'invalid',
    defaultMessage: 'Invalid',
    description: 'Invalid',
  },
  one: {
    id: 'one',
    defaultMessage: 'one',
    description: 'One',
  },
  tcIncluded: {
    id: 'tcIncluded',
    defaultMessage: 'This is included if {operator} of the following Tailoring Criteria are true:',
    description: 'Tailoring Criteria included message',
  },
  noResults: {
    id: 'noResults',
    defaultMessage: 'No results found.',
    description: 'No results found message',
  },
  toggleAll: {
    id: 'toggleAll',
    defaultMessage: 'Select / Deselect All',
    description: 'Toggle all options',
  },
  expandAll: {
    id: 'expandAll',
    defaultMessage: 'Expand all',
    description: 'Expand all accordions',
  },
  collapseAll: {
    id: 'collapseAll',
    defaultMessage: 'Collapse all',
    description: 'Collapse all accordions',
  },
  tailoredBuildingBlocks: {
    id: 'tailoredBuildingBlocks',
    defaultMessage: `{count, plural,
      =1 {Tailored Building Block{separator}}
      other {Tailored Building Blocks{separator}}
    }`,
    description: 'Tailored Building Blocks',
  },
  tailoredDesignObligations: {
    id: 'tailoredDesignObligations',
    defaultMessage: `{count, plural,
      =1 {Tailored Design Obligation{separator}}
      other {Tailored Design Obligations{separator}}
    }`,
    description: 'Tailored Design Obligations',
  },
  noInfoCustom: {
    id: 'noInfoCustom',
    defaultMessage: 'No {nodeType} available.',
    description: 'No information available.',
  },
  description: {
    id: 'description',
    defaultMessage: 'Description{separator}',
    description: 'Description',
  },
  expert: {
    id: 'expert',
    defaultMessage: 'Content Experts{separator}',
    description: 'Experts of the Design Obligation node (name and org code)',
  },
  expertPlaceholder: {
    id: 'expertPlaceholder',
    defaultMessage: 'Name and ORG code of the expert(s)',
    description: 'Placeholder for the experts input field',
  },
  referencedDesignObligations: {
    id: 'referencedDesignObligations',
    defaultMessage: 'Referenced Design Obligations{separator}',
    description: 'referencedDesignObligations',
  },
  parentDescription: {
    id: 'parentDescription',
    defaultMessage: 'Parent Description{separator}',
    description: 'Parent Description',
  },
  productClass: {
    id: 'productClass',
    defaultMessage: `{count, plural,
      =1 {Product Class{separator}}
      =2 {Product Classes{separator}}
      other {Product Class{separator}}
    }`,
    description: 'Product Class',
  },
  includedInTailoringWhen: {
    id: 'includedInTailoringWhen',
    defaultMessage: `{operatorType, select,
      OR {Included in tailoring when Product Class is any of these{separator}}
      AND {Included in tailoring when Product Class is all of these{separator}}
      other {Product Class{separator}}
    }`,
    description:
      'Label of product class based on configuring operator type (OR = any, AND = all, undefined = Product Class)',
  },
  businessUnit: {
    id: 'businessUnit',
    defaultMessage: `{count, plural,
      =1 {Business Unit{separator}}
      other {Business Units{separator}}
    }`,
    description: 'Business Unit',
  },
  dataBlock: {
    id: 'dataBlock',
    defaultMessage: `{count, plural,
      =1 {Data Block{separator}}
      other {Data Blocks{separator}}
    }`,
    description: 'Data Block',
  },
  targetState: {
    id: 'targetState',
    defaultMessage: 'Target State{separator}',
    description: 'Target State',
  },
  deadlineMaturityStages: {
    id: 'deadlineMaturityStages',
    defaultMessage: 'Deadline Maturity Levels{separator}',
    description: 'Deadline Maturity Levels',
  },
  tailoredOperators: {
    id: 'tailoredOperators',
    defaultMessage: 'Tailored Operators{separator}',
    description: 'Tailored Operators',
  },
  tailoredItems: {
    id: 'tailoredItems',
    defaultMessage: 'Tailored Items{separator}',
    description: 'Tailored Items of a TC',
  },
  why: {
    id: 'why',
    defaultMessage: 'Why{separator}',
    description: 'Why',
  },
  consequencesOfNoResponse: {
    id: 'consequencesOfNoResponse',
    defaultMessage: 'Consequences of No Response{separator}',
    description: 'Consequences of No Response',
  },
  preconditionAssumptions: {
    id: 'preconditionAssumptions',
    defaultMessage: 'Precondition Assumptions{separator}',
    description: 'Precondition Assumptions',
  },
  definitionOfDone: {
    id: 'definitionOfDone',
    defaultMessage: 'Definition of Done{separator}',
    description: 'Definition of Done',
  },
  follower: {
    id: 'follower',
    defaultMessage: 'Follower{separator}',
    description: 'Follower of a Maturity Level',
  },
  followers: {
    id: 'followers',
    defaultMessage: 'Followers{separator}',
    description: 'Followers of a Maturity Level',
  },
  linkText: {
    id: 'linkText',
    defaultMessage: 'Link Text{separator}',
    description: 'Link Text',
  },
  classification: {
    id: 'classification',
    defaultMessage: 'Classification{separator}',
    description: 'Classification',
  },
  linkType: {
    id: 'linkType',
    defaultMessage: 'Link Type{separator}',
    description: 'Link Type',
  },
  link: {
    id: 'link',
    defaultMessage: 'Link{separator}',
    description: 'Link',
  },
  generalDetails: {
    id: 'generalDetails',
    defaultMessage: 'General Details',
    description: 'General Details',
  },
  information: {
    id: 'information',
    defaultMessage: 'Information',
    description: 'Information',
  },
  competencies: {
    id: 'competencies',
    defaultMessage: 'Competencies',
    description: 'Competencies',
  },
  iTrigger: {
    id: 'iTrigger',
    defaultMessage: 'I Trigger{separator}',
    description: 'I Trigger',
  },
  deadlineDataBlocks: {
    id: 'deadlineOfDataBlocks',
    defaultMessage: 'Deadline Data Blocks{separator}',
    description: 'Deadline Data Blocks',
  },
  mySuccessor: {
    id: 'mySuccessor',
    defaultMessage: 'My Successor{separator}',
    description: 'My Successor',
  },
  iAmNeededBy: {
    id: 'iAmNeededBy',
    defaultMessage: 'I am needed by{separator}',
    description: 'I am needed by',
  },
  noInfo: {
    id: 'noInfo',
    defaultMessage: 'No Information.',
    description: 'No Information',
  },
  selectComponentNoOptions: {
    id: 'selectComponent.noOptions',
    defaultMessage: 'No options available',
    description: 'No options available',
  },
  designObligation: {
    id: 'designObligation',
    defaultMessage: 'Design Obligation',
    description: 'Design Obligation',
  },
  tailoringCriteria: {
    id: 'tailoringCriteria',
    defaultMessage: 'Tailoring Criteria',
    description: 'Tailoring Criteria',
  },
  tailoringOperator: {
    id: 'tailoringOperator',
    defaultMessage: 'Tailoring Operator',
    description: 'Tailoring Operator',
  },
  configuringOperator: {
    id: 'configuringOperator',
    defaultMessage: 'Configuring Operator',
    description: 'Configuring Operator',
  },
  maturityStage: {
    id: 'maturityStage',
    defaultMessage: 'Maturity Level',
    description: 'Maturity Level',
  },
  myDeadlineMaturityStage: {
    id: 'myDeadlineMaturityStage',
    defaultMessage: 'My Deadline Maturity Levels',
    description: 'My Deadline Maturity Levels',
  },
  myTriggerMaturityStage: {
    id: 'myTriggerMaturityStage',
    defaultMessage: 'My Trigger Maturity Levels',
    description: 'My Trigger Maturity Levels',
  },
  followingMaturityStages: {
    id: 'followingMaturityStages',
    defaultMessage: 'My Follower Maturity Levels',
    description: 'My Follower Maturity Levels',
  },
  iTriggerMaturityStage: {
    id: 'iTriggerMaturityStage',
    defaultMessage: 'I Trigger Maturity Levels',
    description: 'I Trigger Maturity Levels',
  },
  triggeredDataBlocks: {
    id: 'triggeredDataBlocks',
    defaultMessage: 'I Trigger Data Blocks',
    description: 'I Trigger Data Blocks',
  },
  buildingBlock: {
    id: 'buildingBlock',
    defaultMessage: 'Building Block',
    description: 'Building Block',
  },
  buildingBlocksPlural: {
    id: 'buildingBlocksPlural',
    defaultMessage: 'Building Blocks',
    description: 'Building Blocks plural',
  },
  bulkUpload: {
    id: 'bulkUpload',
    defaultMessage: 'Bulk Upload',
    description: 'Bulk Upload',
  },
  dataBlocksPlural: {
    id: 'dataBlocks',
    defaultMessage: 'Data Blocks',
    description: 'Data Blocks',
  },
  tailoringCriteriaPlural: {
    id: 'tailoringCriteriaPlural',
    defaultMessage: 'Tailoring Criteria',
    description: 'Tailoring Criteria',
  },
  maturityStagesPlural: {
    id: 'maturityStagesPlural',
    defaultMessage: 'Maturity Levels',
    description: 'Maturity Levels',
  },
  maturityLevelSetsPlural: {
    id: 'maturityLevelSetsPlural',
    defaultMessage: 'Maturity Level Sets',
    description: 'Maturity Level Sets',
  },
  memberOfMaturityLevelSets: {
    id: 'memberOfMaturityLevelSets',
    defaultMessage: 'Member of Maturity Level Sets{separator}',
    description: 'Label for maturity level set memberships shown on maturity level details',
  },
  myMaturityLevels: {
    id: 'myMaturityLevels',
    defaultMessage: 'My Maturity Levels{separator}',
    description: 'Label for the list of maturity stages connected to an MLSQ',
  },
  competenciesPlural: {
    id: 'competenciesPlural',
    defaultMessage: 'Competencies',
    description: 'Competencies',
  },
  informationsPlural: {
    id: 'informationsPlural',
    defaultMessage: 'Informations',
    description: 'Informations',
  },
  businessUnitsPlural: {
    id: 'businessUnitsPlural',
    defaultMessage: 'Business Units',
    description: 'Business Units',
  },
  configurationsPlural: {
    id: 'configurationsPlural',
    defaultMessage: 'Configurations',
    description: 'Configurations',
  },
  businessUnitSpecificPlural: {
    id: 'businessUnitSpecificPlural',
    defaultMessage: 'Business Unit Specific',
    description: 'Business Unit Specific',
  },
  buildingBlocks: {
    id: 'buildingBlocks',
    defaultMessage: `{number, plural,
      =1 {# Building Block}
      other {# Building Blocks}
    }`,
    description: 'Building Blocks plural form with count',
  },
  edit: {
    id: 'edit',
    defaultMessage: 'Edit',
    description: 'Edit',
  },
  search: {
    id: 'search',
    defaultMessage: 'Search',
    description: 'Search',
  },
  new: {
    id: 'new',
    defaultMessage: 'New',
    description: 'New',
  },
  filters: {
    id: 'filters',
    defaultMessage: 'Filters',
    description: 'Filters',
  },
  view: {
    id: 'view',
    defaultMessage: 'View',
    description: 'View',
  },
  groupBy: {
    id: 'groupBy',
    defaultMessage: 'Group by:',
    description: 'Group by',
  },
  servicePortal: {
    id: 'servicePortal',
    defaultMessage: 'myIT Service Portal',
    description: 'Service Portal name',
  },
  tutorial: {
    id: 'tutorial',
    defaultMessage: 'Tutorial',
    description: 'Tutorial name',
  },
  details: {
    id: 'details',
    defaultMessage: 'Details',
    description: 'Details',
  },
  connections: {
    id: 'connections',
    defaultMessage: 'Connections',
    description: 'Connections',
  },
  save: {
    id: 'save',
    defaultMessage: 'Save',
    description: 'Save',
  },
  cancel: {
    id: 'cancel',
    defaultMessage: 'Cancel',
    description: 'Cancel',
  },
  previous: {
    id: 'previous',
    defaultMessage: 'Previous',
    description: 'Previous',
  },
  next: {
    id: 'next',
    defaultMessage: 'Next',
    description: 'Next',
  },
  version: {
    id: 'version',
    defaultMessage: 'Version{separator}',
    description: 'Version',
  },
  unpublished: {
    id: 'unpublished',
    defaultMessage: 'Unpublished',
    description: 'Unpublished',
  },
  published: {
    id: 'published',
    defaultMessage: 'Published',
    description: 'Published',
  },
  name: {
    id: 'name',
    defaultMessage: 'Name{separator}',
    description: 'Name',
  },
  failedValidation: {
    id: 'failedValidation',
    defaultMessage: 'Validation not passed',
    description: 'Validation not passed',
  },
  failedValidationDescription: {
    id: 'failedValidationDescription',
    defaultMessage: 'Resolve errors to proceed to publishing',
    description: 'Resolve errors to proceed to publishing',
  },
  passedValidation: {
    id: 'passedValidation',
    defaultMessage: 'Validation passed',
    description: 'Validation passed',
  },
  passedValidationDescription: {
    id: 'passedValidationDescription',
    defaultMessage: 'Ready for publishing. Check the previous version in the Published tab.',
    description: 'Ready for publishing',
  },
  publishedValidation: {
    id: 'publishedValidation',
    defaultMessage: 'This version has been published',
    description: 'This version has been published',
  },
  publishedValidationDescription: {
    id: 'publishedValidationDescription',
    defaultMessage: 'Go to the "Unpublished" section to edit',
    description: 'Go to the "Unpublished" section to edit',
  },
  appliesTo: {
    id: 'appliesTo',
    defaultMessage: 'Applies to',
    description: 'Applies to',
  },
  reasonForChange: {
    id: 'reasonForChange',
    defaultMessage: 'Reason for Change',
    description: 'Reason for Change',
  },
  buSpecificText: {
    id: 'buSpecificText',
    defaultMessage: 'BU Specific Text{separator}',
    description: 'BU Specific Text',
  },
  addingTo: {
    id: 'addingTo',
    defaultMessage: 'Adding to',
    description: 'Adding to',
  },
  parent: {
    id: 'parent',
    defaultMessage: 'Parent',
    description: 'Parent',
  },
  parentNodeLabel: {
    id: 'parentNodeLabel',
    defaultMessage: 'Parent{separator}',
    description: 'Parent node data row label',
  },
  goToPublishing: {
    id: 'goToPublishing',
    defaultMessage: 'Publish All Changes',
    description: 'Go to Publishing',
  },
  messageToConsumer: {
    id: 'messageToConsumer',
    defaultMessage: 'Message to Consumer',
    description: 'Message to Consumer',
  },
  changeComment: {
    id: 'changeComment',
    defaultMessage: 'Change Comment',
    description: 'Change Comment',
  },
  publish: {
    id: 'publish',
    defaultMessage: 'Finalise Publishing',
    description: 'Finalise Publishing',
  },
  publishChanges: {
    id: 'publishChanges',
    defaultMessage: 'Publish your changes',
    description: 'Publish your changes',
  },
  upmPublishedMessage: {
    id: 'upmPublishedMessage',
    defaultMessage: 'Universal process model successfully published',
    description: 'Universal process model successfully published',
  },
  wikiPagesUpdateSuccess: {
    id: 'wikiPagesUpdateSuccess',
    defaultMessage: 'Wiki pages update initiated successfully',
    description: 'Wiki pages update initiated successfully',
  },
  wikiPagesUpdateFailed: {
    id: 'wikiPagesUpdateFailed',
    defaultMessage: 'Wiki pages update initiation failed',
    description: 'Wiki pages update initiation failed',
  },
  sort: {
    id: 'sort',
    defaultMessage: 'Sort{separator}',
    description: 'Sort',
  },
  nodeUpdated: {
    id: 'nodeUpdated',
    defaultMessage: 'Updated',
    description: 'Node updated',
  },
  oldValue: {
    id: 'oldValue',
    defaultMessage: 'Old Value',
    description: 'Old Value',
  },
  newValue: {
    id: 'newValue',
    defaultMessage: 'New Value',
    description: 'New Value',
  },
  changedBy: {
    id: 'changedBy',
    defaultMessage: '{date} at {time} - {author}',
    description: 'Changed By',
  },
  changeType: {
    id: 'changeType',
    defaultMessage: '{type} Changed',
    description: 'Change Type',
  },
  question: {
    id: 'question',
    defaultMessage: 'Question{separator}',
    description: 'Question',
  },
  backToOverview: {
    id: 'backToOverview',
    defaultMessage: 'Back to Overview',
    description: 'Back to Overview',
  },
  backToHome: {
    id: 'backToHome',
    defaultMessage: 'Back to home',
    description: 'Back to home',
  },
  unpublishedDesignObligations: {
    id: 'unpublishedDesignObligations',
    defaultMessage: 'Unpublished Design Obligations',
    description: 'Unpublished Design Obligations',
  },
  invalidDesignObligations: {
    id: 'invalidDesignObligations',
    defaultMessage: 'Invalid Design Obligations',
    description: 'Invalid Design Obligations',
  },
  delete: {
    id: 'delete',
    defaultMessage: 'Delete',
    description: 'Delete',
  },
  featureNotImplemented: {
    id: 'featureNotImplemented',
    defaultMessage: 'Feature not implemented yet',
    description: 'Feature not implemented yet',
  },
  isReviewRequired: {
    id: 'isReviewRequired',
    defaultMessage: 'Review by consumer required',
    description: 'Review by consumer required',
  },
  reviewRequiredByBusinessUnits: {
    id: 'reviewRequiredByBusinessUnits',
    defaultMessage: 'Select business units for review',
    description: 'Select business units for review',
  },
  publishingTab: {
    id: 'publishingTab',
    defaultMessage: 'PUBLISHING: {nodeName}',
    description: 'Publishing Tab',
  },
  updateOnlyChangedWikiPages: {
    id: 'updateOnlyChangedWikiPages',
    defaultMessage: 'Automatic',
    description: 'Automatic',
  },
  plmWikiText: {
    id: 'plmWikiText',
    defaultMessage: 'PLM-Wiki',
    description: 'Link to the PLM-Wiki page',
  },
  updateOptionText: {
    id: 'updateOptionText',
    defaultMessage: 'Update',
    description: 'Update',
  },
  selectUpdateOptionText: {
    id: 'selectUpdateOptionText',
    defaultMessage: 'Select update option',
    description: 'Select update option',
  },
  updateOnly: {
    id: 'updateOnly',
    defaultMessage: 'Update only changed content',
    description: 'Update only changed content',
  },
  updateAll: {
    id: 'updateAll',
    defaultMessage: 'Update the complete content',
    description: 'Update the complete content',
  },
  infoTooltipMessage: {
    id: 'infoTooltipMessage',
    defaultMessage: `The confluence wiki export runs in the Background. After the export is finished, the application will update an Export Protocol {link}`,
    description: 'Information about the protocol page',
  },
  infoTooltipLinkText: {
    id: 'infoTooltipLinkText',
    defaultMessage: `here`,
    description: 'Text for the link in the tooltip',
  },
  publishSingleNode: {
    id: 'publishSingleNode',
    defaultMessage: 'Publish',
    description: 'Publish Single Node',
  },
  closeAllTabs: {
    id: 'closeAllTabs',
    defaultMessage: 'Close all tabs',
    description: 'Close all open tabs on the topbar on Maintainer page',
  },
  more: {
    id: 'more',
    defaultMessage: 'more',
    description: 'More',
  },
});
